import React, { FC } from 'react';

import ReactTable from '@nhl/nhl-react-ui/lib/NhlTable/ReactTable';

import { AwardRecipients as AwardRecipientsType } from '../../../types/AwardTypes';
import { Franchise } from '../../../types/FranchiseTypes';

import columnDefinitions from './columnDefinitions';

import './styles.scss';

type Props = {
    recipients: AwardRecipientsType[];
    franchises: Franchise[];
    type: string;
    slug: string;
    footnote?: string;
    franchiseAwards?: boolean;
};

const AwardRecipients: FC<Props> = ({ recipients, franchises, type, slug, footnote, franchiseAwards = false }) => {
    const columns = columnDefinitions(type, slug, franchises);
    const visibleColumns = columns.filter((x) => x.show !== false);

    // If there is a position column the length will then be 4
    if (visibleColumns.length <= 4 && franchiseAwards) {
        visibleColumns[0].width = 180;
        visibleColumns[visibleColumns.length - 1].maxWidth = undefined;
    }

    return (
        <div className="trophy-recipients-container">
            <ReactTable
                className={`trophy-historic-table -striped -highlight ${
                    visibleColumns.length <= 4 ? 'smallTable' : ''
                }`}
                columns={visibleColumns}
                data={recipients}
                pageSize={recipients.length}
                resizable={false}
                showPagination={false}
            />
            {footnote && <div className="footnote">{footnote}</div>}
        </div>
    );
};

export default AwardRecipients;
